import React, { useEffect, useState } from 'react';

function formatIndianCurrency(number) {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 2
    }).format(number);
}

function ReportsSummary() {
    const [summary, setSummary] = useState({
        totalPurchaseInvoiceAmount: 0,
        totalPurchasePayments: 0,
        totalSalesInvoiceAmount: 0,
        totalSalesReceiptsAmount: 0,
        totalAdhocPaymentsAmount: 0,
    });

    useEffect(() => {
        fetch('/reports/totalsummary') // Adjust endpoint as necessary
            .then(res => res.json())
            .then(data => setSummary(data))
            .catch(error => console.error('Summary fetch error:', error));
    }, []);

    const profit = summary.totalSalesReceiptsAmount - summary.totalPurchasePayments - summary.totalAdhocPaymentsAmount;
    const pendingReceivables = summary.totalSalesInvoiceAmount - summary.totalSalesReceiptsAmount;

    return (
        <div style={{
            marginBottom: 20,
            padding: 16,
            border: '1px solid #ccc',
            borderRadius: 8,
            maxWidth: 800,
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f9f9f9'
        }}>
            <h3 style={{ marginBottom: 16, borderBottom: '1px solid #bbb', paddingBottom: 8 }}>Totals Summary</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14 }}>
                <div>
                    <span style={{ fontWeight: 'bold' }}>Purchase Invoice :</span> {formatIndianCurrency(summary.totalPurchaseInvoiceAmount)},&nbsp;
                    <span style={{ fontWeight: 'bold' }}>Purchase Payments:</span> {formatIndianCurrency(summary.totalPurchasePayments)}
                </div>
                <div>
                    <span style={{ fontWeight: 'bold' }}>Sales Invoice :</span> {formatIndianCurrency(summary.totalSalesInvoiceAmount)},&nbsp;
                    <span style={{ fontWeight: 'bold' }}>Sales Receipts :</span> {formatIndianCurrency(summary.totalSalesReceiptsAmount)}
                </div>
                <div>
                    <span style={{ fontWeight: 'bold' }}>Adhoc Payments :</span> {formatIndianCurrency(summary.totalAdhocPaymentsAmount)}
                </div>
                <div style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                    Profit (Receipts - Payments - AdHoc): {formatIndianCurrency(profit)}
                </div>
                <div style={{ color: '#d84315', fontWeight: 'bold' }}>
                    Pending Receivables (Sales Invoice - Receipts): {formatIndianCurrency(pendingReceivables)}
                </div>
            </div>
        </div>
    );

}

export default ReportsSummary;
